<template>
  <div class="order">
    <van-nav-bar title="学生信息" left-arrow @click-left="$router.go(-1)" />
    <van-cell-group  >
          <van-cell title="头像" >
            <van-image
              v-if="childrenInfo.photo"
                round
                width="4rem"
                height="4rem"
                :src="childrenInfo.photo"
              />
            <van-image
              v-else
                round
                width="4rem"
                height="4rem"
                src="/img/default-avatar.png"
              />
          </van-cell>
          <van-cell title="姓名" :value="childrenInfo.name" />
          <van-cell title="学号" :value="childrenInfo.student_no" />
          <van-cell title="班级"  >
            {{ childrenInfo.grade_name }}{{childrenInfo.class_name}}
          </van-cell>
          <van-cell title="电话" :value="childrenInfo.phone" />

         
        </van-cell-group>
  </div>
</template>

<script>
export default {
  name: 'ChildrenInfo',
  components: {
    
  },
  data () {
    return {
      childrenInfo:{}

    }
  },
  mounted () {
    this.childrenInfo=JSON.parse(localStorage.getItem('childrenInfo'))
  },
  methods: {
    

  },
  watch: {
    
  }
}
</script>

<style lang="less" scoped>
.order {
  background-color: #fafafa;
}
.van-tabs {
  position: sticky;
  top: 0;
}

.access_box{
  margin-top: 5px;
  margin-bottom: 5px;
  border-top: 1px solid #ddd;

}
</style>
